// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__1d07d","icon":"footer_icon__118gD"};